import { render } from "./ClassReportDetail.vue?vue&type=template&id=2d3de9dd&ts=true"
import script from "./ClassReportDetail.vue?vue&type=script&lang=ts"
export * from "./ClassReportDetail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__